import React, { ReactElement } from "react";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import { useSelector } from "react-redux";

const EnterNetworking = (): ReactElement => {
  const isAuthorized = useSelector((state) => state.Auth?.status);

  return (
    <>
      <div className="modal modal--netw-soon">
        <div className="modal__header">
          <div className="modal__title">Войдите в нетворкинг!</div>
          <button
            className="modal__close"
            onClick={() => {
              Middleware.Ui.Modal.close();
            }}
          />
        </div>
        <div className="modal__body">
          <div className="modal__desc">
            Активируйте свой профиль в нетворкинге, чтобы назначать встречи и обмениваться
            визитками.
          </div>
          <Link
            className="btn btn--blue-white"
            to={isAuthorized === "authorized" ? `/cabinet/networking` : `/auth/signin`}
            onClick={() => {
              Middleware.Ui.Modal.close();
            }}
          >
            Войти!
          </Link>
        </div>
      </div>
    </>
  );
};

export default EnterNetworking;
